const openMobileNav = () => {
  const closeIcon = document.getElementById("nav-toggler-icon-close");
  const openIcon = document.getElementById("nav-toggler-icon-open");

  const mobileNav = document.getElementById("header-mobile-nav");

  mobileNav.style.width = "100%";

  closeIcon.style.display = "block";
  openIcon.style.display = "none";

  setTimeout(() => {
    const navElements = document.querySelectorAll("#header-mobile-nav > *");
    navElements.forEach((el) => {
      el.style.opacity = 1;
    });
  }, 200);

  return true;
};

const closeMobileNav = () => {
  const closeIcon = document.getElementById("nav-toggler-icon-close");
  const openIcon = document.getElementById("nav-toggler-icon-open");

  const mobileNav = document.getElementById("header-mobile-nav");

  const navElements = document.querySelectorAll("#header-mobile-nav > *");
  navElements.forEach((el) => {
    el.style.opacity = 0;
  });

  closeIcon.style.display = "none";
  openIcon.style.display = "block";

  setTimeout(() => {
    mobileNav.style.width = "0";
  }, 200);

  return false;
};

document.addEventListener("DOMContentLoaded", () => {
  let mobileNavOpen = false;

  document
    .querySelector("#nav-toggler")
    .addEventListener("click", (e) => {
      e.preventDefault();

      if (mobileNavOpen) {
        mobileNavOpen = closeMobileNav();
      } else {
        mobileNavOpen = openMobileNav();
      }
    });

  let lastScrollY = window.scrollY;
  const header = document.querySelector('#shopify-section-header');

  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY && currentScrollY > 80) {
      header.classList.add('header-hidden');
      mobileNavOpen = closeMobileNav();
    } else {
      header.classList.remove('header-hidden');
    }

    lastScrollY = currentScrollY;
  });
});
